window.CONFIGURATION = {
  env: process.env.NODE_ENV,
  sentryDsn: process.env.SENTRY_DSN,
  sentryEnvironment: process.env.SENTRY_ENVIRONMENT,
  sentryReleaseVersion: process.env.SENTRY_RELEASE_VERSION,
  plaidEnv: process.env.PLAID_ENV || "sandbox",
  plaidKey: process.env.PLAID_KEY || "db6312d5f0828c03e6eda4831ace7b",
  stripePublishableKey: process.env.STRIPE_PUBLISHABLE_KEY || "pk_test_Y7byiIyWmjqy4Xy7fjArJdPl",
  amplitudeApiKey: process.env.AMPLITUDE_KEY || 'fd2c6df53fde89925d4602d61785ad45',
  statuspageEmbedCode: process.env.STATUSPAGE_EMBED_CODE,
  newRelicAccountId: process.env.NEW_RELIC_ACCOUNT_ID,
  newRelicLicenseKey: process.env.NEW_RELIC_LICENSE_KEY,
  newRelicApplicationId: process.env.NEW_RELIC_APPLICATION_ID,
  googleMapsKey: `&key=${process.env.GOOGLE_MAPS_JS_KEY || 'AIzaSyCxmha8wa6V2LP3PRgLePsIABcYxZ_-oww'}`,
  googleRecaptchaSiteKey: process.env.GOOGLE_RECAPTCHA_SITE_KEY,
  smartlookProjectKey: process.env.SMARTLOOK_PROJECT_KEY,
  apiUrl: process.env.API_URL || 'http://localhost:5000',
  apiVersion: process.env.API_VERSION,
  intercomAppId: process.env.INTERCOM_APP_ID,
}
